import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "buttons" }

import { reactive } from 'vue';
import { VueFinalModal } from 'vue-final-modal';


export default /*@__PURE__*/_defineComponent({
  __name: 'ApprovalModal',
  emits: ['reject', 'approve'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const state = reactive({
  comment: ""
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "comment-modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    "content-transition": "vfm-fade"
  }, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tittle" }, [
        _createElementVNode("span", null, "Approve or reject")
      ], -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.comment) = $event)),
        placeholder: "Optional"
      }, null, 512), [
        [_vModelText, state.comment]
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('reject', state.comment)))
        }, "Reject"),
        _createElementVNode("button", {
          class: "accent",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('approve', state.comment)))
        }, "Approve")
      ])
    ]),
    _: 1
  }))
}
}

})